<h2 mat-dialog-title
    *ngIf="!mobile">{{ 'tendering.addToTendering.header' | blah }}</h2>

<mat-dialog-content class="content-container">
    <div class="toggle-container">
        <div>
            <mat-slide-toggle id="copy-attachments"
                [formControl]="copyFileAttachments">
                {{ 'tendering.addToTendering.addAttachments' | blah }}
            </mat-slide-toggle>
        </div>
        <div *ngIf="allowedToCopyUnits"
            class="toggle-with-icon">
            <mat-slide-toggle id=copy-units
                [formControl]="copyUnits">
                {{ 'tendering.addToTendering.addUnits' | blah }}
            </mat-slide-toggle>
            <div class="unit-copy-info-container"
                *ngIf="copyUnits.value">
                <mat-icon id="unit-copy-info"
                    class="warning-color"
                    matTooltip="{{ 'tendering.createNewTenderingDialog.copyUnitDisclaimer' | blah }}"
                    matTooltipClass="hpo"
                    matTooltipPosition="right"
                    [matTooltipShowDelay]="300">warning</mat-icon>
            </div>
        </div>
    </div>

    <div id="tendering-select-container">
        <div style="margin-bottom:1rem;">{{ 'tendering.addToTendering.selectTendering' | blah }}</div>
        <mat-form-field class="fullwidth">
            <mat-label>{{ 'tendering.addToTendering.tenderingPlaceholder' | blah }}</mat-label>
            <input type="text"
                id="tendering-select"
                aria-label="Number"
                matInput
                [formControl]="tenderingControl"
                [matAutocomplete]="auto">
            <mat-icon matSuffix>search</mat-icon>
            <mat-autocomplete #auto="matAutocomplete"
                [displayWith]="displayFn">
                <mat-option [value]="option"
                    *ngFor="let option of filteredOptions | async">
                    {{ option.Identifier }} {{option.Name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div *ngIf="validToAdd"
        class="adding-info">
        <p> {{ 'tendering.addToTendering.addingItemsInfoText' | blah:[addingItemsInfoText, source] }}<br />
            <b>{{ tenderingControl.value.IwmId }} {{ tenderingControl.value.Identifier }} <span
                    *ngIf="tenderingControl.value.Identifier && tenderingControl.value.Name">-</span>
                {{tenderingControl.value.Name}}</b>
        </p>
        <div style="margin: auto 2rem auto 0;">
            <hpo-spinner *ngIf="addInProgress"
                size="18"
                color="primary"></hpo-spinner>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end"
    *ngIf="!mobile">
    <hpo-button id="close-dialog-btn"
        (click)="close()"> {{ 'default.cancel' | blah }} </hpo-button>
    <hpo-button id="save-dialog-btn"
        color="accent"
        [disabled]="!validToAdd || addInProgress"
        (click)="addItemsToTendering()">
        {{ 'default.add' | blah }}
    </hpo-button>
</mat-dialog-actions>